export default __webpack_public_path__ + "static/media/avatar-6.b7d35e73.png";